/*
 * /resource-edit?entityRef=… — промежуточная страница кнопки «Изменить»: читает текущие параметры
 * ресурса (бэкенд-плагин viva-edit) и открывает шаблон изменения с ними. Ошибка чтения (файл ресурса
 * удалён из репозитория, ресурс создан не шаблоном) — сообщение со ссылкой назад.
 */
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useAsync from 'react-use/esm/useAsync';
import { Typography } from '@material-ui/core';
import {
  Content,
  Header,
  Link,
  Page,
  Progress,
  ResponseErrorPanel,
} from '@backstage/core-components';
import { discoveryApiRef, fetchApiRef, useApi } from '@backstage/core-plugin-api';
import { parseEntityRef } from '@backstage/catalog-model';
import { editTemplateUrl, fetchEditForm } from '../../lib/resourceEdit';

export const ResourceEditPage = () => {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const navigate = useNavigate();
  const entityRef = new URLSearchParams(useLocation().search).get('entityRef') ?? '';
  const state = useAsync(() => fetchEditForm({ discoveryApi, fetchApi }, entityRef), [entityRef]);

  useEffect(() => {
    if (state.value) navigate(editTemplateUrl(state.value.template, state.value.formData), { replace: true });
  }, [state.value, navigate]);

  let back = '/catalog';
  try {
    const ref = parseEntityRef(entityRef);
    back = `/catalog/${ref.namespace}/${ref.kind.toLowerCase()}/${ref.name}`;
  } catch {
    // без entityRef — назад в каталог
  }
  return (
    <Page themeId="tool">
      <Header title="Изменение ресурса" subtitle={entityRef} />
      <Content>
        {state.error ? (
          <>
            <ResponseErrorPanel error={state.error} />
            <Typography variant="body2">
              <Link to={back}>Вернуться к ресурсу</Link>
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="body2">Читаю текущие параметры из репозитория…</Typography>
            <Progress />
          </>
        )}
      </Content>
    </Page>
  );
};
